import type React from 'react';

import Button, { type ButtonArrows, type ButtonVariant } from '@helsenorge/designsystem-react/components/Button';

interface ArrowButtonProps {
  text: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  variant?: ButtonVariant; // e.g. "outline", "primary", etc.
  arrow?: ButtonArrows;
}

const ArrowButton: React.FC<ArrowButtonProps> = ({ text, href, onClick, className = '', variant = 'outline', arrow = 'icon' }) => (
  <div className={className}>
    <Button arrow={arrow} variant={variant as ButtonVariant} href={href} onClick={onClick}>
      {text}
    </Button>
  </div>
);

export default ArrowButton;
